import { Search } from 'lucide-react'
import FilterControl from '../../../../../../table/FilterControl'

export default function ProgramadosFilters({
  filters,
  setFilters,
  query,
  setQuery
}) {
  return (
    <div className='mt-2 rounded-3xl border border-gray-200 bg-gray-50 p-4 shadow-sm'>
      <div className='flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between'>
        <div className='flex flex-wrap gap-3'>
          <div className='min-w-[150px]'>
            <FilterControl
              label='Estado'
              value={filters.status}
              onChange={value => setFilters(prev => ({ ...prev, status: value }))}
              options={[
                { value: 'Todos', label: 'Todos' },
                { value: 'Activos', label: 'Activos' },
                { value: 'Inactivos', label: 'Inactivos' },
                { value: 'Completados', label: 'Completados' }
              ]}
            />
          </div>

          <div className='min-w-[150px]'>
            <FilterControl
              label='Frecuencia'
              value={filters.frequency}
              onChange={value => setFilters(prev => ({ ...prev, frequency: value }))}
              options={[
                { value: 'Todas', label: 'Todas' },
                { value: 'Diario', label: 'Diario' },
                { value: 'Semanal', label: 'Semanal' },
                { value: 'Mensual', label: 'Mensual' },
                { value: 'Trimestral', label: 'Trimestral' },
                { value: 'Semestral', label: 'Semestral' },
                { value: 'Anual', label: 'Anual' }
              ]}
            />
          </div>

          <div className='min-w-[150px]'>
            <FilterControl
              label='Tipo Documento'
              value={filters.docType}
              onChange={value => setFilters(prev => ({ ...prev, docType: value }))}
              options={[
                { value: 'Todos', label: 'Todos' },
                { value: 'Documentos Nacionales', label: 'Documentos Nacionales' },
                { value: 'Facturas de Exportación', label: 'Facturas de Exportación' },
                {
                  value: 'Notas de Crédito de Exportación',
                  label: 'Notas de Crédito de Exportación'
                }
              ]}
            />
          </div>
        </div>

        <div className='relative w-full xl:max-w-sm xl:min-w-[320px]'>
          <Search
            size={16}
            className='pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400'
          />
          <input
            value={query}
            onChange={e => setQuery(e.target.value)}
            placeholder='Buscar por cliente, RUT o estado'
            className='w-full rounded-lg border border-slate-300 bg-white py-2 pl-9 pr-3 text-sm text-slate-700 outline-none transition focus:border-accent2/40 focus:ring-2 focus:ring-accent2/15'
          />
        </div>
      </div>
    </div>
  )
}
